export const PREV_STEP = 'PREV_STEP';
export const NEXT_STEP = 'NEXT_STEP';
